import { serviceApi } from '~/api/service';

export const slotsUrl = (queryParams) => `slots?${queryParams}`;

export const slotsApi = {
  fetch: (queryParams, options = {}, byPassErrorCodes = []) =>
    serviceApi.fetchJSON(slotsUrl(queryParams), options, undefined, byPassErrorCodes),
  fetchJSONFromAPI: (queryParams, options = {}, byPassErrorCodes = []) =>
    serviceApi.fetchJSONFromAPI(slotsUrl(queryParams), options, undefined, byPassErrorCodes),
};
